import React from "react";
import { Navigate } from "react-router-dom";
import useSessionStorage from "./useSessionStorage";

const RequiresAuth = ({ children }) => {
  const [token] = useSessionStorage("token");

  if (!token) {
    // Store the current path for redirect after login
    const currentPath = window.location.pathname + window.location.search;
    sessionStorage.setItem("redirectAfterLogin", currentPath);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default RequiresAuth;
